/*
 * Single source of truth for institute facts that the public marketing surfaces
 * state more than once. Same rule as src/config/contact.js: no component may
 * hardcode these strings — import them.
 *
 * This file exists because the founding year and the students-mentored figure
 * were each written out independently in two places (a proof-strip stat and the
 * founder bio) and had ALREADY drifted: the credentials line said "Teaching
 * since 2013" while the bio next to it said "since 2014". Two literals stating
 * one fact will always drift eventually; one constant cannot.
 *
 * STUDENTS_MENTORED is stored WITHOUT its "+" / "over " qualifier so each call
 * site can phrase it naturally ("2,400+" in a stat tile, "over 2,400" in prose)
 * while the number itself stays single-sourced. It is a display string, not a
 * number, because the grouping comma is part of how it is rendered.
 */

/* Confirmed: 2014. Do not reintroduce 2013 anywhere. */
export const FOUNDING_YEAR = '2014';

export const STUDENTS_MENTORED = '2,400';
